import React, { useEffect, useMemo, useRef, useState, forwardRef } from 'react';
import GoodsItem from '../GoodsItem';
import styles from './index.modules.less';

const COLUMN_GAP = 9;
const ITEM_GAP = 18;
const DEFAULT_ITEM_HEIGHT = 280;

const areHeightsEqual = (currentHeights, nextHeights) => {
  const currentKeys = Object.keys(currentHeights);
  const nextKeys = Object.keys(nextHeights);
  if (currentKeys.length !== nextKeys.length) return false;
  return nextKeys.every((key) => currentHeights[key] === nextHeights[key]);
};

export default forwardRef(({ name, list, sourceTag }) => {
  const itemRefs = useRef({});
  const [itemHeights, setItemHeights] = useState({});
  const products = list || [];

  const measureItems = () => {
    const nextHeights = {};
    products.forEach((item, index) => {
      const node = itemRefs.current[index];
      if (node) {
        nextHeights[index] = node.getBoundingClientRect().height;
      }
    });
    setItemHeights((currentHeights) => {
      return areHeightsEqual(currentHeights, nextHeights) ? currentHeights : nextHeights;
    });
  };

  useEffect(() => {
    const nodes = products.map((item, index) => itemRefs.current[index]).filter(Boolean);
    const resizeObserver =
      typeof window !== 'undefined' && window.ResizeObserver
        ? new window.ResizeObserver(measureItems)
        : null;
    const imageLoadHandlers = [];

    nodes.forEach((node) => {
      if (resizeObserver) {
        resizeObserver.observe(node);
      }
      node.querySelectorAll('img').forEach((image) => {
        const handleLoad = measureItems;
        image.addEventListener('load', handleLoad);
        imageLoadHandlers.push({ image, handleLoad });
      });
    });

    measureItems();
    if (!resizeObserver && typeof window !== 'undefined') {
      window.addEventListener('resize', measureItems);
    }

    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      imageLoadHandlers.forEach(({ image, handleLoad }) => {
        image.removeEventListener('load', handleLoad);
      });
      if (!resizeObserver && typeof window !== 'undefined') {
        window.removeEventListener('resize', measureItems);
      }
    };
  }, [products]);

  const { layouts, containerHeight } = useMemo(() => {
    const columnHeights = [0, 0];
    const nextLayouts = products.map((item, index) => {
      const columnIndex = columnHeights[1] < columnHeights[0] ? 1 : 0;
      const top = columnHeights[columnIndex];
      const height = itemHeights[index] || DEFAULT_ITEM_HEIGHT;
      columnHeights[columnIndex] = top + height + ITEM_GAP;
      return { columnIndex, top };
    });

    return {
      layouts: nextLayouts,
      containerHeight: products.length ? Math.max(...columnHeights) - ITEM_GAP : 0
    };
  }, [itemHeights, products]);

  return (
    <div
      className={styles.container}
      style={{
        height: containerHeight
      }}
      title={name}>
      {products.map((item, index) => {
        const layout = layouts[index];
        return (
          <div
            key={`hot-sale-product-${index}`}
            ref={(node) => {
              itemRefs.current[index] = node;
            }}
            className={styles['hot-sale-product']}
            style={{
              top: layout.top,
              left: layout.columnIndex === 0 ? 0 : `calc(50vw - ${COLUMN_GAP + 15}px)`
            }}>
            <GoodsItem item={item} index={index} sourceTag={sourceTag} />
          </div>
        );
      })}
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/components/Tabs/Components/PageList/index.jsx